import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LicenseQueryKey } from './queryKey';
export const useDeleteTemporaryLicense = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((id) => api.base
        .delete(`/api/License/TemporaryLicense/${id}`)
        .then(res => res.data), {
        onSuccess: (_result, id) => {
            queryClient.setQueryData([LicenseQueryKey.Info], (old) => {
                if (!old || !old.temporaryLicenses)
                    return old;
                return Object.assign(Object.assign({}, old), { temporaryLicenses: old.temporaryLicenses.filter((l) => l.id !== id) });
            });
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { deleteTemporaryLicense: mutateAsync, isDeleting: isLoading };
};
export default useDeleteTemporaryLicense;
